module.exports = __webpack_public_path__ + "media/images/display/blur-content-4fde90aa35fdaec68f5722d73b22dfcc.png";